export const LEGAL_DOCS = {
    "privacy-policy": {
        title: "Privacy Policy | BookMyVIP",
        heading: "PRIVACY POLICY",
        updated: "Last updated: September 2026",
        sections: [
            {
                h: "What we collect",
                b: "When you submit a booking request on this website, we collect the details you provide: your name, destination, preferred date and group size. When you contact us on WhatsApp, we receive the information you share in that conversation.",
            },
            {
                h: "How we use it",
                b: "We use your details only to respond to your enquiry, suggest suitable VIP table and nightlife options, and arrange the services you request. We do not use your details for unrelated marketing.",
            },
            {
                h: "Sharing with venues",
                b: "To fulfil a booking, we may share relevant details (such as your name and group size) with the venue or service provider involved in your reservation. We do not sell your personal information.",
            },
            {
                h: "Storage and retention",
                b: "Booking request details are stored securely and kept only as long as needed to handle your enquiry and related bookings.",
            },
            {
                h: "Your rights",
                b: "You may ask us to correct or delete your personal details at any time by messaging our concierge on WhatsApp at +66 83 469 1637.",
            },
        ],
    },
    "terms-and-conditions": {
        title: "Terms & Conditions | BookMyVIP",
        heading: "TERMS & CONDITIONS",
        updated: "Last updated: September 2026",
        sections: [
            {
                h: "The service",
                b: "BookMyVIP is a nightlife concierge. We help you arrange VIP tables, bottle-service packages and premium nightlife experiences with independent third-party venues and providers.",
            },
            {
                h: "Availability",
                b: "All bookings are subject to availability and confirmation by the venue. Submitting a request does not guarantee a reservation until our concierge confirms it with you in writing.",
            },
            {
                h: "Venue rules",
                b: "Entry is always subject to each venue's own policies, including legal age requirements, dress codes and identification checks. Venues reserve the right to refuse entry in line with their policies.",
            },
            {
                h: "Payments",
                b: "The booking and payment process varies by venue and experience. Your concierge will explain the available process for your selected experience before you confirm anything.",
            },
            {
                h: "Guest conduct",
                b: "Guests are responsible for their own conduct and compliance with local laws and venue rules throughout the evening.",
            },
            {
                h: "Changes to these terms",
                b: "We may update these terms from time to time. The version published on this page applies to your use of the service.",
            },
        ],
    },
    "booking-policy": {
        title: "Booking Policy | BookMyVIP",
        heading: "BOOKING POLICY",
        updated: "Last updated: September 2026",
        sections: [
            {
                h: "How to book",
                b: "Contact our concierge on WhatsApp at +66 83 469 1637 or submit the booking request form on this website with your destination, date and group size.",
            },
            {
                h: "Confirmation",
                b: "Your booking is confirmed only once our concierge has confirmed the details with you in writing. Advance booking is recommended, especially for weekends, holidays and high-demand venues.",
            },
            {
                h: "Changes and cancellations",
                b: "If your plans change, message our concierge as early as possible. Change and cancellation terms depend on the specific venue and package, and your concierge will explain them before you confirm.",
            },
            {
                h: "Late arrivals and no-shows",
                b: "Venues may release tables that are not claimed within their holding window. If you are running late, message your concierge and we will coordinate with the venue where possible.",
            },
            {
                h: "Deposits and payments",
                b: "Some experiences may require a deposit or prepayment depending on the venue. Where required, this will always be explained to you before you commit.",
            },
        ],
    },
};
